"use strict";
window.WebColor = function(color){
    this.r = 0;
    this.g = 0;
    this.b = 0;
    this.a = 1;

    this.construct(color);
};

$.extend(window.WebColor.prototype, {
    predefined: {
        "aliceblue"             : "#F0F8FF",
        "antiquewhite"          : "#FAEBD7",
        "aqua"                  : "#00FFFF",
        "aquamarine"            : "#7FFFD4",
        "azure"                 : "#F0FFFF",
        "beige"                 : "#F5F5DC",
        "bisque"                : "#FFE4C4",
        "black"                 : "#000000",
        "blanchedalmond"        : "#FFEBCD",
        "blue"                  : "#0000FF",
        "blueviolet"            : "#8A2BE2",
        "brown"                 : "#A52A2A",
        "burlywood"             : "#DEB887",
        "cadetblue"             : "#5F9EA0",
        "chartreuse"            : "#7FFF00",
        "chocolate"             : "#D2691E",
        "coral"                 : "#FF7F50",
        "cornflowerblue"        : "#6495ED",
        "cornsilk"              : "#FFF8DC",
        "crimson"               : "#DC143C",
        "cyan"                  : "#00FFFF",
        "darkblue"              : "#00008B",
        "darkcyan"              : "#008B8B",
        "darkgoldenrod"         : "#B8860B",
        "darkgray"              : "#A9A9A9",
        "darkgreen"             : "#006400",
        "darkkhaki"             : "#BDB76B",
        "darkmagenta"           : "#8B008B",
        "darkolivegreen"        : "#556B2F",
        "darkorange"            : "#FF8C00",
        "darkorchid"            : "#9932CC",
        "darkred"               : "#8B0000",
        "darksalmon"            : "#E9967A",
        "darkseagreen"          : "#8FBC8F",
        "darkslateblue"         : "#483D8B",
        "darkslategray"         : "#2F4F4F",
        "darkturquoise"         : "#00CED1",
        "darkviolet"            : "#9400D3",
        "deeppink"              : "#FF1493",
        "deepskyblue"           : "#00BFFF",
        "dimgray"               : "#696969",
        "dodgerblue"            : "#1E90FF",
        "firebrick"             : "#B22222",
        "floralwhite"           : "#FFFAF0",
        "forestgreen"           : "#228B22",
        "fuchsia"               : "#FF00FF",
        "gainsboro"             : "#DCDCDC",
        "ghostwhite"            : "#F8F8FF",
        "gold"                  : "#FFD700",
        "goldenrod"             : "#DAA520",
        "gray"                  : "#808080",
        "green"                 : "#008000",
        "greenyellow"           : "#ADFF2F",
        "grey"                  : "#808080",
        "honeydew"              : "#F0FFF0",
        "hotpink"               : "#FF69B4",
        "indianred"             : "#CD5C5C",
        "indigo"                : "#4B0082",
        "ivory"                 : "#FFFFF0",
        "khaki"                 : "#F0E68C",
        "lavender"              : "#E6E6FA",
        "lavenderblush"         : "#FFF0F5",
        "lawngreen"             : "#7CFC00",
        "lemonchiffon"          : "#FFFACD",
        "lightblue"             : "#ADD8E6",
        "lightcoral"            : "#F08080",
        "lightcyan"             : "#E0FFFF",
        "lightgoldenrodyellow"  : "#FAFAD2",
        "lightgray"             : "#D3D3D3",
        "lightgreen"            : "#90EE90",
        "lightpink"             : "#FFB6C1",
        "lightsalmon"           : "#FFA07A",
        "lightseagreen"         : "#20B2AA",
        "lightskyblue"          : "#87CEFA",
        "lightslategray"        : "#778899",
        "lightsteelblue"        : "#B0C4DE",
        "lightyellow"           : "#FFFFE0",
        "lime"                  : "#00FF00",
        "limegreen"             : "#32CD32",
        "linen"                 : "#FAF0E6",
        "magenta"               : "#FF00FF",
        "maroon"                : "#800000",
        "mediumaquamarine"      : "#66CDAA",
        "mediumblue"            : "#0000CD",
        "mediumorchid"          : "#BA55D3",
        "mediumpurple"          : "#9370DB",
        "mediumseagreen"        : "#3CB371",
        "mediumslateblue"       : "#7B68EE",
        "mediumspringgreen"     : "#00FA9A",
        "mediumturquoise"       : "#48D1CC",
        "mediumvioletred"       : "#C71585",
        "midnightblue"          : "#191970",
        "mintcream"             : "#F5FFFA",
        "mistyrose"             : "#FFE4E1",
        "moccasin"              : "#FFE4B5",
        "navajowhite"           : "#FFDEAD",
        "navy"                  : "#000080",
        "none"                  : "rgba(0,0,0,0)",
        "oldlace"               : "#FDF5E6",
        "olive"                 : "#808000",
        "olivedrab"             : "#6B8E23",
        "orange"                : "#FFA500",
        "orangered"             : "#FF4500",
        "orchid"                : "#DA70D6",
        "palegoldenrod"         : "#EEE8AA",
        "palegreen"             : "#98FB98",
        "paleturquoise"         : "#AFEEEE",
        "palevioletred"         : "#DB7093",
        "papayawhip"            : "#FFEFD5",
        "peachpuff"             : "#FFDAB9",
        "peru"                  : "#CD853F",
        "pink"                  : "#FFC0CB",
        "plum"                  : "#DDA0DD",
        "powderblue"            : "#B0E0E6",
        "purple"                : "#800080",
        "rebeccapurple"         : "#663399",
        "red"                   : "#FF0000",
        "rosybrown"             : "#BC8F8F",
        "royalblue"             : "#4169E1",
        "saddlebrown"           : "#8B4513",
        "salmon"                : "#FA8072",
        "sandybrown"            : "#F4A460",
        "seagreen"              : "#2E8B57",
        "seashell"              : "#FFF5EE",
        "sienna"                : "#A0522D",
        "silver"                : "#C0C0C0",
        "skyblue"               : "#87CEEB",
        "slateblue"             : "#6A5ACD",
        "slategray"             : "#708090",
        "snow"                  : "#FFFAFA",
        "springgreen"           : "#00FF7F",
        "steelblue"             : "#4682B4",
        "tan"                   : "#D2B48C",
        "teal"                  : "#008080",
        "thistle"               : "#D8BFD8",
        "tomato"                : "#FF6347",
        "transparent"           : "rgba(0,0,0,0)",
        "turquoise"             : "#40E0D0",
        "violet"                : "#EE82EE",
        "wheat"                 : "#F5DEB3",
        "white"                 : "#FFFFFF",
        "whitesmoke"            : "#F5F5F5",
        "yellow"                : "#FFFF00",
        "yellowgreen"           : "#9ACD32",
    },

    construct: function(color){
        var m;
        if (color instanceof WebColor){
            this.setRed(color.getRed());
            this.setGreen(color.getGreen());
            this.setBlue(color.getBlue());
            this.setAlpha(color.getAlpha());
        } else if (typeof color == "string") {
            color = $.trim(color.toLowerCase());
            if (WebColor.prototype.predefined[color]){
                color = WebColor.prototype.predefined[color];
            }
            if (color.match(/^#[0-9a-f]{3}$/i)) {
                this.setRed(parseInt([color[1],color[1]].join(""), 16));
                this.setGreen(parseInt([color[2],color[2]].join(""), 16));
                this.setBlue(parseInt([color[3],color[3]].join(""), 16));
            } else if (color.match(/^#[0-9a-f]{6}$/i)) {
                this.setRed(parseInt([color[1],color[2]].join(""), 16));
                this.setGreen(parseInt([color[3],color[4]].join(""), 16));
                this.setBlue(parseInt([color[5],color[6]].join(""), 16));
            } else if (m = color.match(/rgb\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)/)) {
                this.setRed(parseInt(m[1], 10));
                this.setGreen(parseInt(m[2], 10));
                this.setBlue(parseInt(m[3], 10));
            } else if (m = color.match(/rgba\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d*|\d*\.\d*|\.\d*)\s*\)/)) {
                this.setRed(parseInt(m[1], 10));
                this.setGreen(parseInt(m[2], 10));
                this.setBlue(parseInt(m[3], 10));
                this.setAlpha(parseFloat(m[4]));
            }
        }
    },
    _color_to_hex: function(d){
        var hex = d.toString(16);
        if (hex.length == 1){
            hex = "0" + hex;
        }
        return hex;
    },
    get_smart: function(){
        if (this.a != 1) {
            return this.get_rgba();
        } else {
            return this.get_hex();
        }
    },
    get_rgb: function(){
        return ["rgb(", this.r, ",", this.g, ",", this.b, ")"].join("");
    },
    get_rgba: function(){
        return ["rgba(", this.r, ",", this.g, ",", this.b, ",", this.a, ")"].join("");
    },
    get_hex: function(){
        return ["#", this._color_to_hex(this.r), this._color_to_hex(this.g), this._color_to_hex(this.b)].join("");
    },

    setRed: function(red){
        this.r = Math.min(Math.max(Math.round(red), 0), 255);
        return this;
    },

    setGreen: function(green){
        this.g = Math.min(Math.max(Math.round(green), 0), 255);
        return this;
    },

    setBlue: function(blue){
        this.b = Math.min(Math.max(Math.round(blue), 0), 255);
        return this;
    },

    setAlpha: function(alpha){
        this.a = Math.min(Math.max(alpha, 0), 1);
        return this;
    },

    getRed: function(){
        return this.r;
    },

    getGreen: function(){
        return this.g;
    },

    getBlue: function(){
        return this.b;
    },

    getAlpha: function(){
        return this.a;
    },

    /** имеет ли цвет прозрачность */
    isTransparent: function() {
        return !this.a;
    },

    clone: function(){
        return new WebColor(this);
    },

    /**
     * Считает примерную яркость цвета (без учёта прозрачности)
     */
    getBrightness: function(){
        return (299*this.r + 587*this.g + 114*this.b) / 1000;
    },

    /**
     * Считает примерную яркость цвета (без учёта прозрачности), возвращает true/false
     * Используется для выбора контрастного 
     */
    selectContrastColor: function(dark, bright){
        return this.getBrightness() > 127 ? dark || "#000000" : bright || "#FFFFFF";
    },

    /**
     * Изменить яркость цвета
     * @link https://stackoverflow.com/questions/5560248/programmatically-lighten-or-darken-a-hex-color-or-rgb-and-blend-colors
     * @param percent 0.5
     * @returns WebColor
     * сделать понятнее
     */
    changeBrightness: function(percent){
        var t = percent < 0 ? 0 : 255,
            p = percent < 0 ? -percent : percent;

        this.setRed(this.getRed() + Math.round((t-this.getRed())*p));
        this.setGreen(this.getGreen() + Math.round((t-this.getGreen())*p));
        this.setBlue(this.getBlue() + Math.round((t-this.getBlue())*p));
        return this;
    },
});